<template>
    <div class="page-sidebar">
        <div class="page-sidebar-box">
            <div class="release-menu">
                <div class="menu-row" v-for="(row, index) in releaseMenu" :key="index">
                    <div class="title">{{ row.title }}</div>
                    <div class="menu-submenu">
                        <div
                            :class="['item', activeMenu == item.link ? 'active' : '']"
                            @click="toLink(item.link)"
                            v-for="(item, k) in row.childs"
                            :key="k"
                        >
                            <svg-icon :icon-class="item.icon"></svg-icon>
                            {{ item.name }}
                            <template v-if="item.link == '/manage/accountManage'">
                                <span v-if="$store.getters.userState == 1" class="icon-tip">未认证</span>
                                <span v-if="$store.getters.userState == 2" class="icon-tip">未签署</span>
                                <span v-if="$store.getters.userState == 3 || $store.getters.userState == 4" class="icon-tip">未付费</span>
                                <span v-if="$store.getters.userState == 5" class="icon-tip">已过期</span>
                                <span v-if="renewal" class="icon-tip">可续费</span>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="menu-row">
                    <div class="bg" @click="handleGoSport"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {fetchInitiatedList} from '@/api/distribute';
export default {
    data() {
        return {
            activeMenu: '',
            totalCount: 0
        };
    },
    watch: {
        $route: {
            handler: function () {
                this.setActiveMenu(this.$route);
            },
            deep: true,
            immediate: true,
        },
    },
    computed: {
        // 判断小于等于30天显示可续费按钮
        renewal() {
            const {vip} = this.$store.state.verify || {};
            if (!vip) return false;
            if (this.$store.getters.userState == 2) return false;
            if (this.$store.getters.userState == 5) return false;
            if (this.$store.state.userType == 3) return false;
            return vip && vip.isAdjournment == 1 ? true : false;
        },
        releaseMenu() {
            const {userType} = this.$store.state;
            const {goContractSigned, isEnterpriseUpgrade} = this.$store.getters;
            const menus = [
                {
                    title: '管理中心',
                    childs: [
                        {
                            name: '我的工作台',
                            icon: 'sidebar_work',
                            link: '/manage/dashboard',
                        },
                        {
                            name: '专辑管理',
                            icon: 'sidebar_music',
                            link: '/manage/album',
                        },
                    ],
                },
                {
                    title: userType == 1 ? '个人中心' : '企业中心',
                    childs: [
                        {
                            name: '基本信息',
                            icon: 'sidebar_name',
                            link: '/manage/mainInfo',
                        },
                        {
                            name: '账号管理',
                            icon: 'sidebar_setting',
                            link: '/manage/accountManage',
                        },
                        {
                            name: '收款账号',
                            icon: 'sidebar_card',
                            link: '/manage/bankInfo',
                        },
                        {
                            name: '邀请信息',
                            icon: 'sidebar_friend',
                            link: '/manage/invitation',
                        },
                        {
                            name: '收益&预付',
                            icon: 'sidebar_money',
                            link: '/manage/settlement',
                            white: true,
                        },
                        {
                            name: '趋势数据',
                            icon: 'sidebar_qushi',
                            link: '/manage/trend',
                        },
                    ],
                },
            ];
            //有分账规则 则显示分账通入口
            if (this.totalCount > 0) {
                menus[1].childs.push({
                    name: '分账通',
                    icon: 'sidebar_money',
                    link: '/manage/distribute',
                });
            }
            if (goContractSigned == '') {
                menus[1].childs.push({
                    name: '授权管理',
                    icon: 'sidebar_quan',
                    link: '/manage/authorize',
                });
            }
            if (isEnterpriseUpgrade) {
                menus.push({
                    title: '其他服务',
                    childs: [
                        {
                            name: '升级为企业',
                            icon: 'sidebar_qiye',
                            link: this.$contractRouter('/manage/contract/enterprise/fdd', 'url'),
                        },
                    ],
                });
            }
            return this.getMenus(menus);
        },
    },
    methods: {
        // 过滤菜单数据
        getMenus(menus) {
            const {whiteFlag} = this.$store.state;
            function getMenu(childs) {
                return childs.filter((menu) => {
                    if (menu.childs) menu.childs = getMenu(menu.childs);
                    if (menu.white) {
                        return whiteFlag ? true : false;
                    } else {
                        return true;
                    }
                });
            }
            return getMenu(menus);
        },
        toLink(link) {
            if (link) this.$router.push(link);
        },
        // 设置绑定菜单
        setActiveMenu($route) {
            let menus = [];
            this.releaseMenu.forEach((row) => (menus = [...menus, ...row.childs]));
            const active = menus.find((row) => new RegExp(row.link).test($route.path));
            if (active) return (this.activeMenu = active.link);
            return (this.activeMenu = '');
        },
        async initMenuData() {
            try {
                const response = await fetchInitiatedList(1, 20);
                const {state, result} = response.data;
                if (state) {
                    this.totalCount = result.totalCount || 0;
                }
            } catch (error) {
                console.error('获取菜单数据失败:', error);
            }
        },
        handleGoSport() {
            window.open('https://wap.showstart.com/pages/special/springSeed/apply', '_blank');
        }

    },
    mounted(){
        this.initMenuData();
        window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    }
};
</script>
<style lang="scss" scoped>
.page-sidebar {
    width: 300px;
    min-width: 300px;
    position: relative;
    z-index: 2;

    .page-sidebar-box {
        .release-menu {
            .menu-row {
                padding: 40px 30px;
                background-color: #fff;
                margin-bottom: 20px;
                border-radius: 10px;
                &:last-child {
                    cursor: pointer;
                    padding: 5px 0;
                    transition: opacity 0.3s, height 0.3s;
                    .bg {
                        width: 100%;
                        height: 100px;
                        background: url('~@/assets/img/sidebar/chunmiao.png') center no-repeat;
                        background-size: 100% 100%;
                    }
                    &.hide {
                        opacity: 0;
                        height: 0;
                        padding: 0;
                        margin-bottom: 0;
                    }
                }
            }

            .title {
                font-size: 12px;
                font-weight: 400;
                color: $-text-500;
                line-height: 12px;
                margin-bottom: 20px;
            }

            .menu-submenu {
                .item {
                    border-radius: 5px;
                    cursor: pointer;
                    padding: 0 30px;
                    height: 48px;
                    display: flex;
                    align-items: center;
                    margin: 5px 0;

                    .svg-icon {
                        margin-right: 15px;
                        font-size: 14px;
                    }

                    &.active,
                    &:hover {
                        background: $--color-base;
                        color: $-text-50;
                    }

                    .icon-tip {
                        background: #e4d6ff;
                        color: $--color-primary;
                        font-size: 10px;
                        border-radius: 4px;
                        opacity: 0.6;
                        line-height: 24px;
                        padding: 0 7px;
                        margin-left: 20px;
                    }
                }
            }
        }
    }
}
</style>
